export const baseSegment = 'support'

export const pathname = '/support'

export const supportChatNavigation = {
  pathname
}
